import { uniqWith } from 'lodash/array';
import {
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_SECTOR,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import compileSector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/compilers/compileSector';
import compileRoundTable from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/compilers/compileRoundTable';
import compileRectangleTable from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/compilers/compileRectangleTable';

function compileUniqueSeatParents(parents, changeSet) {
    uniqWith(parents, (a, b) => (a.objectType === b.objectType && a.id === b.id)).forEach((parent) => {
        if (parent.objectType === OBJECT_TYPE_SECTOR) {
            compileSector(parent, changeSet);
        }
        if (parent.objectType === OBJECT_TYPE_ROUND_TABLE) {
            compileRoundTable(parent, changeSet);
        }
        if (parent.objectType === OBJECT_TYPE_RECTANGLE_TABLE) {
            compileRectangleTable(parent, changeSet);
        }
    });
}

export default compileUniqueSeatParents;
